module.exports = "/_next/static/images/16bf3efdbeb853aafcf0c5efc8b3dda2-woman-with-iphone-short-form@0.75x.jpg.webp";